// extracted by mini-css-extract-plugin
export var csatScore = "_i4-5";
export var header = "_i4-1";
export var panelWrapper = "_i4-2";
export var postPreview = "_i4-3";
export var rightContent = "_i4-0";
export var wrappingText = "_i4-4";